const motifGrid = document.getElementById("motifGrid");
const previewImage = document.getElementById("previewImage");

const prevBtn = document.getElementById("prevBtn");
const nextBtn = document.getElementById("nextBtn");

const totalImages = 140;
let imagesPerPage = window.innerWidth <= 768 ? 12 : 30;
let currentPage = 0;

function loadPage(page) {

    motifGrid.innerHTML = "";

    const start = page * imagesPerPage;
    const end = Math.min(start + imagesPerPage, totalImages);

    for (let i = start + 1; i <= end; i++) {

        const imageNumber = totalImages - i + 1;

        const imagePath =
            `https://cdn.shopify.com/s/files/1/1013/1993/4281/files/animal_${imageNumber}.png`;

        const card = document.createElement("div");
        card.classList.add("motif-item");

        card.innerHTML = `
            <img src="${imagePath}" alt="">
        `;

        card.addEventListener("click", () => {

            document.querySelectorAll(".motif-item").forEach(item => {
                item.classList.remove("active");
            });

            card.classList.add("active");

            previewImage.src = imagePath;
        });

        motifGrid.appendChild(card);
    }
}

loadPage(0);

nextBtn.addEventListener("click", () => {

    const maxPage = Math.ceil(totalImages / imagesPerPage) - 1;

    if (currentPage < maxPage) {
        currentPage++;
        loadPage(currentPage);
    }
});

prevBtn.addEventListener("click", () => {

    if (currentPage > 0) {
        currentPage--;
        loadPage(currentPage);
    }
});

// ================================
// TEXT INPUTS
// ================================

const row1 = document.getElementById("row1");
const row2 = document.getElementById("row2");
const row3 = document.getElementById("row3");

const previewRow1 = document.getElementById("previewRow1");
const previewRow2 = document.getElementById("previewRow2");
const previewRow3 = document.getElementById("previewRow3");

const counters = document.querySelectorAll(".input-box span");

function updateCounter() {
    counters[0].textContent = `${row1.value.length}/17`;
    counters[1].textContent = `${row2.value.length}/17`;
    counters[2].textContent = `${row3.value.length}/17`;
}

function updateText() {

    previewRow1.textContent = row1.value.trim();
    previewRow2.textContent = row2.value.trim();
    previewRow3.textContent = row3.value.trim();

    updateCounter();

    const rows = [
        previewRow1,
        previewRow2,
        previewRow3
    ];


    /* =========================================
       SHOW / HIDE EMPTY ROWS
    ========================================= */

    rows.forEach(row => {

        row.style.display =
            row.textContent.trim() !== ""
                ? "block"
                : "none";

        row.style.whiteSpace = "nowrap";
        row.style.wordBreak = "normal";
        row.style.overflow = "visible";
        row.style.flexShrink = "0";

    });


    const visibleRows =
        rows.filter(row =>
            row.textContent.trim() !== ""
        );


    if (!visibleRows.length) {
        return;
    }


    /* =========================================
       FIND LONGEST TEXT
    ========================================= */

    let longest = 0;

    visibleRows.forEach(row => {

        longest = Math.max(
            longest,
            row.textContent.length
        );

    });


    /* =========================================
       STARTING FONT SIZE
    ========================================= */

    let baseSize;


    if (visibleRows.length === 1) {

        if (longest <= 5) {

            baseSize = 74;

        } else if (longest <= 10) {

            baseSize = 64;

        } else {

            baseSize = 52;

        }

    } else if (visibleRows.length === 2) {

        if (longest <= 5) {

            baseSize = 54;

        } else if (longest <= 10) {

            baseSize = 52;

        } else {

            baseSize = 42;

        }

    } else {

        if (longest <= 5) {

            baseSize = 40;

        } else if (longest <= 10) {

            baseSize = 36;

        } else {

            baseSize = 30;

        }

    }


    /* =========================================
       APPLY INITIAL SIZE
    ========================================= */

    visibleRows.forEach(row => {

        row.style.fontSize =
            baseSize + "px";

        row.style.lineHeight =
            "1.08";

    });


    /* =========================================
       WAIT FOR BROWSER TO CALCULATE
    ========================================= */

    requestAnimationFrame(() => {

        const textContainer =
            document.querySelector(
                ".name-label-configurator .preview-text"
            );


        if (!textContainer) {
            return;
        }


        /*
         * Available space inside the
         * white label.
         */

        const availableWidth =
            textContainer.clientWidth;

        const availableHeight =
            textContainer.clientHeight;


        if (
            availableWidth <= 0 ||
            availableHeight <= 0
        ) {
            return;
        }


        /* =====================================
           AUTOMATIC FIT
        ===================================== */

        let size = baseSize;


        while (size > 12) {

            visibleRows.forEach(row => {

                row.style.fontSize =
                    size + "px";

            });


            /*
             * Check horizontal overflow.
             */

            const widthOverflow =
                visibleRows.some(row => {

                    return (
                        row.scrollWidth >
                        availableWidth
                    );

                });


            /*
             * Check vertical overflow.
             */

            const heightOverflow =
                textContainer.scrollHeight >
                availableHeight;


            /*
             * Everything fits.
             */

            if (
                !widthOverflow &&
                !heightOverflow
            ) {

                break;

            }


            /*
             * Reduce font size.
             */

            size--;

        }


        /* =====================================
           FINAL SETTINGS
        ===================================== */

        visibleRows.forEach(row => {

            row.style.fontSize =
                size + "px";

            row.style.lineHeight =
                "1.08";

            row.style.whiteSpace =
                "nowrap";

            row.style.wordBreak =
                "normal";

            row.style.overflow =
                "visible";

        });

    });

}

row1.addEventListener("input", updateText);
row2.addEventListener("input", updateText);
row3.addEventListener("input", updateText);

updateText();

// ================================
// TABS
// ================================

const motivBtn = document.getElementById("motivBtn");
const backgroundBtn = document.getElementById("backgroundBtn");
const textBtn = document.getElementById("textBtn");

const motifSection = document.getElementById("motifSection");
const backgroundTab = document.getElementById("backgroundTab");
const textTab = document.getElementById("textTab");

function clearTabs() {
    motivBtn.classList.remove("active");
    backgroundBtn.classList.remove("active");
    textBtn.classList.remove("active");
}

motivBtn.addEventListener("click", () => {
    clearTabs();
    motivBtn.classList.add("active");

    motifSection.style.display = "block";
    backgroundTab.style.display = "none";
    textTab.style.display = "none";
});

backgroundBtn.addEventListener("click", () => {
    clearTabs();
    backgroundBtn.classList.add("active");

    motifSection.style.display = "none";
    backgroundTab.style.display = "block";
    textTab.style.display = "none";
});

textBtn.addEventListener("click", () => {
    clearTabs();
    textBtn.classList.add("active");

    motifSection.style.display = "none";
    backgroundTab.style.display = "none";
    textTab.style.display = "block";
});

// ================================
// BACKGROUNDS
// ================================

const backgroundGrid =
    document.getElementById("backgroundGrid");

const nameLabel =
    document.querySelector(".name-label");

const bgColors = [
    "#d3e0df", "#d7c9e5", "#cfd5b8", "#c8d9e3", "#edd7cf", "#eadcc6",
    "#a9c7c8", "#ddd5d5", "#d7ae90", "#7faa78", "#a4af7a", "#bf8a90",
    "#98d5cf", "#ececec", "#f2ae58", "#f5f5f5", "#000000", "#ff1208",
    "#a7d8d8", "#d9e6e5", "#f6d8d8", "#d9d7e9", "#efe8dc",
    "#8fb7b5", "#c9c5c5", "#b88c70", "#739d6f", "#9ca56f", "#b07f85",
    "#91d4cb", "#ffffff", "#f2b15c", "#f7f7f7", "#008000", "#0000FF",
    "#00FFFF", "#FF00FF", "#808080", "#FFA500", "#FF6F61", "#AAF0D1",
    "#E6E6FA", "#657383", "#2C3E50", "#228B22", "#EDC9AF", "#FFF8E7",
    "#CCFF00", "#FF3399", "#FEE499"
];

let currentBgPage = 0;
const bgPerPage = 24;

function loadBackgroundPage(page) {

    backgroundGrid.innerHTML = "";

    const start = page * bgPerPage;
    const end =
        Math.min(start + bgPerPage, bgColors.length);

    for (let i = start; i < end; i++) {

        const card = document.createElement("div");

        card.classList.add("bg-card");
        card.style.background = bgColors[i];

        card.addEventListener("click", () => {

            document.querySelectorAll(".bg-card")
                .forEach(c =>
                    c.classList.remove("active")
                );

            card.classList.add("active");

            nameLabel.style.background =
                bgColors[i];
        });

        backgroundGrid.appendChild(card);
    }
}

loadBackgroundPage(0);

// ================================
// TEXT COLORS
// ================================

const textColorGrid = document.getElementById("textColorGrid");

const textColors = [
    "#000000", "#ffffff", "#cccccc", "#888888", "#444444", "#ff9999",
    "#ff4444", "#ff0000", "#90ee90", "#ffcc99", "#ff9900", "#ffd700",
    "#b8e986", "#66bb00", "#00aa44", "#006633", "#87ceeb", "#5a9bd4",
    "#3377aa", "#003366", "#9999ff", "#4f5fe6", "#232fbb", "#c49a7c"
];

function loadTextColors() {
    textColorGrid.innerHTML = "";

    textColors.forEach(color => {
        const card = document.createElement("div");
        card.classList.add("text-color-card");
        card.style.background = color;

        card.addEventListener("click", () => {
            document.querySelectorAll(".text-color-card")
                .forEach(c => c.classList.remove("active"));

            card.classList.add("active");

            previewRow1.style.color = color;
            previewRow2.style.color = color;
            previewRow3.style.color = color;
        });

        textColorGrid.appendChild(card);
    });
}

loadTextColors();

// ================================
// FONTS
// ================================

document
.querySelectorAll(".font-card")
.forEach(card => {

    card.addEventListener("click", () => {

        document
        .querySelectorAll(".font-card")
        .forEach(item =>
            item.classList.remove("active")
        );

        card.classList.add("active");

        const font = card.dataset.font;

        previewRow1.style.fontFamily = font;
        previewRow2.style.fontFamily = font;
        previewRow3.style.fontFamily = font;
    });

});



// BACKGROUND PAGINATION

const bgPrevBtn = document.getElementById("bgPrevBtn");
const bgNextBtn = document.getElementById("bgNextBtn");

bgNextBtn.addEventListener("click", () => {

    const maxPage =
        Math.ceil(bgColors.length / bgPerPage) - 1;

    if (currentBgPage < maxPage) {
        currentBgPage++;
        loadBackgroundPage(currentBgPage);
    }

});

bgPrevBtn.addEventListener("click", () => {

    if (currentBgPage > 0) {
        currentBgPage--;
        loadBackgroundPage(currentBgPage);
    }

});




let quantity = 1;

const qtyMinus = document.getElementById("qtyMinus");
const qtyPlus = document.getElementById("qtyPlus");
const qtyValue = document.getElementById("qtyValue");
const addToCartBtn = document.getElementById("addToCartBtn");
const variantIdInput = document.getElementById("variantId");

qtyPlus.addEventListener("click", () => {
    quantity++;
    qtyValue.textContent = quantity;
});

qtyMinus.addEventListener("click", () => {
    if (quantity > 1) {
        quantity--;
        qtyValue.textContent = quantity;
    }
});

addToCartBtn.addEventListener("click", () => {
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantIdInput.value,
            quantity: quantity,
            properties: {
                "Rad 1": row1.value,
                "Rad 2": row2.value,
                "Rad 3": row3.value,
                "Motiv": previewImage.src,
                "Bakgrund": nameLabel.style.background || "#ffffff",
                "Textfärg": previewRow1.style.color || "#000000",
                "Font": previewRow1.style.fontFamily || "Arial"
            }
        })
    })
    .then(res => res.json())
    .then(() => {
        window.location.href = "/cart";
    });
});